// Constants for different requests for current reducer
export default {
  users: 'USERS',
  user: 'USER',
  createUser: 'CREATE_USER',
  updateUser: 'UPDATE_USER',
  requestPasswordReset: 'USER_PASSWORD_RESET_REQ',
  validatePasswordReset: 'USER_PASSWORD_RESET_VALIDATE',
  confirmPasswordReset: 'USER_PASSWORD_RESET_CONFIRM',
};
